import React, { useEffect, useState, useContext } from "react";
import authContext from "contexts/auth/authContext";

import { SettingsContext } from "./index";
import { useGetSettings } from "shared/hooks/api/use-get-settings";
import { getStorageValue, setStorageValue } from "shared/storage";

const Settings = (props) => {
    const { user, authenticated } = useContext(authContext);
    const { data: response } = useGetSettings(authenticated);
    const [settings, setSettings] = useState((state) => {
        const storedNotifications = getStorageValue("notifications");

        return {
            ...state,
            globalSettings: {
                appliedFiltersLocalStorageExpirationInMinutes: 0,
                environment: "",
                roles: {},
            },
            intakeConfigFeatures: {},
            globalNotifications: { messages: storedNotifications ? storedNotifications : [] },
            taskSettings: {},
            cxhTaxonomy: {},
            featureFlags: {},
            imageEditingBulkComplete: {
                "imageediting.standard": {
                    applicableTaskDescriptions: [],
                    notApplicableTaskDescriptions: [],
                },
                "imageediting.premium": {
                    applicableTaskDescriptions: [],
                    notApplicableTaskDescriptions: [],
                },
            },
            locationDataSources: [],
            routePermissions: [],
            slaV2Options: {},
        };
    });

    const hasReadOnlyPermission = (currentPermission) => {
        if (!user.permissions) {
            return;
        }

        const hasPermission = user.permissions.find((permission) => permission.name === currentPermission);

        if (!hasPermission) {
            return;
        }

        return hasPermission.isReadOnly;
    };

    const hasPermission = (currentPermission) => {
        if (!user.permissions) {
            return false;
        }

        return !!user.permissions.find((permission) => permission.name === currentPermission);
    };

    useEffect(() => {
        if (response?.globalNotifications?.messages) {
            if (response.globalNotifications.messages.length === 0) {
                localStorage.removeItem("notifications");
            } else {
                setStorageValue("notifications", response.globalNotifications.messages);
            }
        }

        if (response?.duplicateMatch) {
            setStorageValue("duplicateMatch", response.duplicateMatch.enabled);
        }

        return setSettings({
            ...settings,
            ...response,
            locationDataSources: response?.locationDataSources
                .sort((a, b) => a.name.localeCompare(b.name))
                .map(({ id, name }) => {
                    return {
                        text: name,
                        value: name,
                    };
                }),
        });
    }, [response]);

    return <SettingsContext.Provider value={{ settings, hasReadOnlyPermission, hasPermission }}>{props.children}</SettingsContext.Provider>;
};

export default Settings;
